import { Fragment } from "react"



const Scholarship = ()=>{
    return (
        <Fragment>
            <iframe src="https://forms.zohopublic.com/globedwise/form/NGOformforSinghStudyCirlce/formperma/4Vg-_HibVM_Y7nGFaW8dtjygdlBTW6v5uV7ygWTgv3k" style={{height:"200vh",width:"100%", border:"none" }} frameborder="0"></iframe>
        </Fragment>
    )
}

export default Scholarship